import React, { useState } from "react";
import { createPortal } from "react-dom";
import ImageLightbox from "../Bulletin/Posts/ImageLightbox";

// A photo you can press to see full screen, with the arrows moving through the
// rest of its set (Sam, 2026-09-26: the Blog's photos did nothing when clicked).
// The viewer is the Bulletin's own, drawn over the whole page.
function Zoomable({ images, index = 0, label, children }) {
  const [open, setOpen] = useState(false);
  // In a set, each photo says which one it is, so a screen reader doesn't
  // announce four identical buttons.
  const inSet = images.length > 1;
  const which = `photo ${index + 1} of ${images.length}`;
  const name = label
    ? `See ${label}${inSet ? `, ${which}` : ""} full screen`
    : `See ${inSet ? which : "this photo"} full screen`;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={name}
        className="block w-full p-0 m-0 border-0 bg-transparent cursor-zoom-in hover:opacity-95"
      >
        {children}
      </button>
      {open &&
        createPortal(
          <ImageLightbox images={images} startIndex={index} onClose={() => setOpen(false)} />,
          document.body
        )}
    </>
  );
}

export default Zoomable;
